export const socialsData = {
    github: 'https://github.com/MrutyunjayaSahoo',
    linkedIn: 'https://www.linkedin.com/in/mrutyunjaya-sahoo12/',
    instagram: 'https://www.instagram.com/_m_sahoo/',
    twitter: 'https://x.com/MSahoo112',
    hashnode:'https://hashnode.com/@MSahoo',
    stackblitz:'https://stackblitz.com/@MrutyunjayaSahoo'
}